// 线上兼容的版本号

import { versionCompare, isPure, getStorage  } from '../utils';

// 云挂机跳转盒子 版本号兼容判定 安卓h5 4.5.4  安卓半原生 4.4.0
export const redirBoxNewVersion = () => {
  const device_info = getStorage('device_info');
  return (!isPure() && versionCompare(device_info.sdkVersion, '4.5.4')) || (isPure() && versionCompare(device_info.sdkVersion, '4.4.0'))
}

// 云挂机功能 版本号兼容判定 安卓h5 4.5.4  安卓半原生 4.5.0
export const cloudOldVersion = () => {
  const device_info = getStorage('device_info');
  return (!isPure() && !versionCompare(device_info.sdkVersion, '4.5.4')) || (isPure() && !versionCompare(device_info.sdkVersion, '4.5.0'))
}